module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"irrigation":"Irrigation"},"es":{"irrigation":"Irrigación"},"sw":{"irrigation":"Umwagiliaji"}}')
  delete Component.options._Ctor
}
